import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { HotkeysService, HotkeysShortcutPipe } from '@ngneat/hotkeys';

@Component({
  selector: 'app-shortcut-help',
  standalone: true,
  imports: [HotkeysShortcutPipe],
  template: `
    <div class="rounded-lg bg-gray-100 p-4 dark:bg-gray-700">
      @if (hotkeys?.length > 0) {
        @for (hotkeyGroup of hotkeys; track hotkeyGroup) {
          <table class="w-full text-left">
            @if (hotkeyGroup.group) {
              <thead class="bg-gray-200 dark:bg-gray-700">
                <tr>
                  <th colspan="2" class="px-4 py-2">
                    {{ hotkeyGroup.group }}
                  </th>
                </tr>
              </thead>
            }
            <tbody>
              @for (hotkey of hotkeyGroup.hotkeys; track hotkey) {
                <tr>
                  <td class="px-4 py-2">
                    {{ hotkey.description }}
                  </td>
                  <td class="px-4 py-2">
                    <kbd
                      class="rounded bg-gray-300 px-2 py-1 text-sm dark:bg-gray-900"
                      [innerHTML]="hotkey.keys | hotkeysShortcut"></kbd>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      } @else {
        <div class="text-center text-gray-500 dark:text-gray-400">
          현 페이지는 단축키가 설정되지 않았습니다.
        </div>
      }
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortcutHelpComponent {
  hotkeysService = inject(HotkeysService);
  hotkeys = this.hotkeysService.getShortcuts();
}
